import { ajax } from "../utils";

const initCookies = () => {
  const cookieDisclaimer = document.getElementById('cookie-notif');
  if (cookieDisclaimer) {
    const close = cookieDisclaimer.querySelector('.close');
    if(close){
      close.addEventListener('click', function () {
        cookieDisclaimer.remove();
        ajax('/request/cookies', function () {
        }, 'GET', {}, {}, true, false);
      });
    }

    const accepts = cookieDisclaimer.querySelectorAll('.accept');
    if(accepts){
      accepts.forEach(function(accept){
        accept.addEventListener('click', function () {
          cookieDisclaimer.remove();
          ajax('/request/cookies', function () {
          }, 'GET', {}, {}, true, false);
        });
      });
    }

    const refuses = cookieDisclaimer.querySelectorAll('.refuse');
    if(refuses){
      refuses.forEach(function(refuse){
        refuse.addEventListener('click', function () {
          cookieDisclaimer.remove();
          ajax('/request/refuse-cookies', function () {
          }, 'GET', {}, {}, true, false);
        });
      });
    }
  }
}

export { initCookies }
